import { render, staticRenderFns } from "./EffUploadModal.vue?vue&type=template&id=89123a70&scoped=true&"
import script from "./EffUploadModal.vue?vue&type=script&lang=js&"
export * from "./EffUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./EffUploadModal.vue?vue&type=style&index=0&id=89123a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89123a70",
  null
  
)

export default component.exports